import React from "react"
import { getAllCurrencies } from "../../utils"
import SelectField from "../SelectField"

const currencyList = Object.keys(getAllCurrencies()).map(currency => ({
  value: currency,
  label: currency
}))

function CurrencyField(props) {
  return (
    <span>
      <SelectField
        {...props}
        isSearchable={true}
        options={currencyList}
        defaultValue={{ value: "none", label: "" }}
      />
    </span>
  )
}

export default CurrencyField
